var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "#FFF6EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#FDD9AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.315 15.5837C20.1956 11.883 24.6946 9.50021 29.75 9.5C29.9489 9.49999 30.1397 9.57901 30.2803 9.71966C30.421 9.86031 30.5 10.0511 30.5 10.25C30.5 15.3056 28.1173 19.805 24.4165 22.6859C24.4715 23.0329 24.5 23.3883 24.5 23.75C24.5 27.4779 21.4779 30.5 17.75 30.5C17.3358 30.5 17 30.1642 17 29.75V25.6185C16.9907 25.6118 16.9816 25.6049 16.9726 25.5978C16.0206 24.8429 15.158 23.9803 14.4031 23.0282C14.3958 23.019 14.3887 23.0096 14.3818 23H10.25C9.83579 23 9.5 22.6642 9.5 22.25C9.5 18.5221 12.5221 15.5 16.25 15.5C16.612 15.5 16.9677 15.5286 17.315 15.5837ZM23 14.75C21.7574 14.75 20.75 15.7574 20.75 17C20.75 18.2426 21.7574 19.25 23 19.25C24.2426 19.25 25.25 18.2426 25.25 17C25.25 15.7574 24.2426 14.75 23 14.75Z",
    fill: "#FBA12B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2604 25.2418C13.5924 24.9942 13.6607 24.5242 13.4131 24.1922C13.1654 23.8602 12.6955 23.7918 12.3635 24.0395C11.0821 24.9954 10.25 26.5256 10.25 28.2499C10.25 28.5255 10.2713 28.7966 10.3125 29.0615C10.3626 29.3842 10.6157 29.6373 10.9384 29.6875C11.2034 29.7286 11.4744 29.7499 11.75 29.7499C13.4743 29.7499 15.0045 28.9178 15.9604 27.6365C16.2081 27.3045 16.1397 26.8345 15.8077 26.5869C15.4757 26.3392 15.0058 26.4075 14.7581 26.7396C14.0731 27.6577 12.9808 28.2499 11.75 28.2499C11.75 27.0191 12.3422 25.9268 13.2604 25.2418Z",
    fill: "#FBA12B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPerformance);
export default __webpack_public_path__ + "static/media/icons-performance.ee4cc70e6b2011de30552ab15d537b67.svg";
export { ForwardRef as ReactComponent };